define((require) => {
    "use strict";

    var Backbone                      = require("backbone"),
        ProjectMetadata               = require("ui/editor/project/ProjectMetadata"),
        ProjectCollection             = require("ui/editor/project/ProjectCollection"),
        UrlUtil                       = require("shared/util/UrlUtil"),
        RestApi                       = require("shared/services/RestApi"),
        Configuration = require("shared/services/Configuration"),
        LoggedInUserState             = require("shared/ui/user/LoggedInUserState");

    /**
     * A collection of project meta data.
     *
     * @class ProjectMetadataCollection
     * @constructor
     * @author Poul Henriksen
     */
    return Backbone.Collection.extend({

        model: function(attrs) {
            return new ProjectMetadata(attrs);
        },

        options: null,

        initialize: function(attrs, options) {
            this.options = options;
        },

        url: function() {
            const isUserPermissionsEnabled = LoggedInUserState.get("companySettings").get("userPermissionsEnabled");
            const baseURL = isUserPermissionsEnabled ? `${Configuration.msExperiencesUrl}/api/projects/meta/` :
                RestApi.pathToCollection(RestApi.Collections.PROJECTS_META);
            return this.options ? UrlUtil.appendParamObject(baseURL, this.options) : baseURL;
        },

        projects: function() {
            return new ProjectCollection(this.map((projectMetadata) => {
                return projectMetadata.get("model");
            }));
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/project/ProjectMetadataCollection.js